// extracted by mini-css-extract-plugin
export default {"popup_wrap":"awardApprowe_popup_wrap__V0XD7","popup_message":"awardApprowe_popup_message__3kV7A","popup_message_button":"awardApprowe_popup_message_button__c3wUQ"};